var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24.054,
    height: 27.426,
    viewBox: "0 0 24.054 27.426",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11061",
    "data-name": "Group 11061",
    transform: "translate(1.027 1.001)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_10091",
    "data-name": "Path 10091",
    d: "M694.051,381.676c0-4.086-3.8-7.379-8.422-7.212a7.826,7.826,0,0,0-7.757,7.422c-.04,5.093-1.572,7.944-2.737,9.38a.773.773,0,0,0,.7,1.238h20.257a.772.772,0,0,0,.705-1.23c-1.182-1.453-2.745-4.365-2.745-9.6",
    transform: "translate(-674.965 -374.458)",
    fill: "none",
    stroke: "#f5f5f5",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_10092",
    "data-name": "Path 10092",
    d: "M680.191,390.469c0,.016-.005.031-.005.047a3.739,3.739,0,0,0,7.477,0c0-.016-.005-.031-.005-.047Z",
    transform: "translate(-673.093 -368.829)",
    fill: "none",
    stroke: "#f5f5f5",
    strokeWidth: 2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationIcon);
export default __webpack_public_path__ + "static/media/notification-icon.d31bb322274ef90754a1036df08e0e95.svg";
export { ForwardRef as ReactComponent };